import React, { useEffect } from "react";
import AppBar from "../../Components/header";
import AppProvider from "../../Components/bootstrap";
import { useQueryWithStore, Loading, fetchStart, fetchEnd } from "react-admin";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import { GetOffers } from "./hooks";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { createMuiTheme } from "@material-ui/core/styles";
import copy from "copy-to-clipboard";
import Linkify from "linkifyjs/react";

import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { useHistory } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { useSubscription } from "./hooks";
import Parse from "parse";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const mentorTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#EF8354",
    },
  },
});

const useStyles = makeStyles({
  root: {
    background: "linear-gradient(45deg, #EF8354 30%, #EF8354 90%)",
    borderRadius: 3,
    border: 0,
    color: "white",
    height: 38,
    width: 174,
  },

  paper: {
    marginTop: "15vh",
    margin: "auto",
    maxWidth: "90vw",
    marginBottom: "1vh",
  },

  avatar: {
    width: 150,
    height: 150,
  },

  gridBody: {
    paddingLeft: "5vw",
    marginTop: "1vh",
  },
  gridSwitchBody: {
    paddingLeft: "1vw",
    marginTop: "1vh",
    marginBottom: "1vh",
  },

  content: {
    marginTop: "6%",
  },
  contentSm: {
    marginTop: "20%",
  },
  card: {
    maxWidth: "25vw",
  },
  cardSm: {
    maxWidth: "90vw",
  },
  cardImage: {
    height: "20vh",
    width: "25vw",
  },
  cardImageSm: {
    height: "25vh",
    width: "90vw",
  },

  imageGrid: {
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    margin: "3vh",
  },

  imageScr: {
    padding: "auto",
    maxWidth: "auto",
    minWidth: "auto",
    minHeight: "auto",
    maxHeight: "auto",
  },

  loader: {
    marginTop: "15vh",
    margin: "auto",
    maxWidth: "90vw",
    marginBottom: "1vh",
  },
});

// function urlify(text) {
//   let urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
//   //let urlRegex = /(https?:\/\/[^\s]+)/g;
//   return text.replace(urlRegex, function (url, b, c) {
//     let url2 = c === "www." ? "http://" + url : url;
//     return '<a href="' + url2 + '" target="_blank">' + url + "</a>";
//   });
// }

// const OfferDescriptionComponent = (offer) => {
//   let URL = offer.offerDes ? urlify(offer.offerDes) : null;
//   return URL;
// };

const MentorDetails = (props) => {
  const classes = useStyles();
  const isDesktop = useMediaQuery(mentorTheme.breakpoints.up("md"));
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [SubscriberCount, SetSubscriberCount] = React.useState();
  const { GetSubscriber } = useSubscription(props.location.state.id);
  const { OfferList } = GetOffers(props.location.state.id);
  const dispatch = useDispatch();
  const { loaded, data } = useQueryWithStore({
    type: "getOne",
    resource: "_User",
    payload: { id: props.location.state.id },
  });

  const [userSubscription, setUserSubscription] = React.useState(
    "UnSubscribed"
  );

  (async () => {
    const UserSubscription = await GetSubscriber(props.location.state.id);
    SetSubscriberCount(UserSubscription);
  })();
  useEffect(() => {
    async function MySubscriprion() {
      const Mentor = await Parse.Cloud.run("GetSubscription", {
        mentorId: props.location.state.id,
      });
      setUserSubscription(Mentor);
    }
    MySubscriprion();
  }, [props.location.state.id]);

  const handleAlignment = async (event, newAlignment) => {
    setUserSubscription(newAlignment);
    try {
      dispatch(fetchStart());
      const UpdatedUserSubscriber = await Parse.Cloud.run("AddSubscriber", {
        mentorId: props.location.state.id,
        subscribed:
          newAlignment === "Subscribed" ? "Subscribed" : "UnSubscribed",
      });

      if (UpdatedUserSubscriber) {
        dispatch(fetchEnd());
      } else {
        dispatch(fetchEnd());
      }
    } catch (e) {
    } finally {
      dispatch(fetchEnd());
    }
  };


  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };


  return (
    <div>
      <AppBar />
      <AppProvider>
        {!loaded ? (
          <Loading className={classes.loader} />
        ) : (
          <div className={isDesktop ? classes.content : classes.contentSm}>
            <Grid
              container
              direction="row"
              justify="flex-start"
              spacing={2}
              className={classes.gridBody}
            >
              <Grid item>
                <Avatar
                  className={classes.avatar}
                  src={data.profileImage ? data.profileImage._url : ""}
                />
              </Grid>
              <Grid
                item
                style={{
                  marginTop: "2vh",
                }}
              >
                <Typography variant="h5">{data.name}</Typography>
                <Typography variant="body1">
                  Industry: {data.industry}
                </Typography>
                <Typography variant="body1">
                  Description: <Linkify>{data.description}</Linkify>
                </Typography>
                <Typography variant="body1">
                  Subscribers: {SubscriberCount}
                </Typography>
              </Grid>
              <Grid
                container
                direction="row"
                justify="flex-start"
                spacing={2}
                className={classes.gridSwitchBody}
              >
                <ToggleButtonGroup
                  value={userSubscription}
                  exclusive
                  onChange={handleAlignment}
                  aria-label="text alignment"
                >
                  <ToggleButton value="Subscribed" aria-label="left aligned">
                    {userSubscription === "Subscribed"
                      ? "Subscribed"
                      : "Subscribe"}
                  </ToggleButton>
                </ToggleButtonGroup>
              </Grid>
            </Grid>
            {OfferList.loaded ? (
              <Grid
                container
                direction={isDesktop ? "row" : "column"}
                className={classes.gridBody}
                spacing={3}
              >
                {OfferList.data.map((offer) => (
                  <Grid item>
                    <Card className={isDesktop ? classes.card : classes.cardSm}>
                      <CardMedia
                        className={
                          isDesktop ? classes.cardImage : classes.cardImageSm
                        }
                        image={offer.offerImage ? offer.offerImage._url : ""}
                        title="Offering 1"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="h2">
                          {offer.offerTitle ? offer.offerTitle : ""}
                        </Typography>
                        <Typography
                          variant="caption"
                          display="block"
                          style={{
                            textAlign: "left",
                            right: "2vh",
                            left: "2vh",
                            fontSize: 15,
                            justify: "center",
                          }}
                        >
                          {/* <OfferDescriptionComponent
                                offerDes={
                                  offer.offerDescription
                                    ? offer.offerDescription
                                    : ""
                                }
                              /> */}
                          <Linkify>
                            {offer.offerDescription
                              ? offer.offerDescription
                              : ""}
                          </Linkify>
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          component="p"
                        >
                          Charges - Rs 100 / 30 mins
                        </Typography>
                        <br />
                        <FacebookShareButton url={window.location.href}>
                          <FacebookIcon size={32} />
                        </FacebookShareButton>
                        &nbsp;&nbsp;
                        <WhatsappShareButton url={window.location.href}>
                          <WhatsappIcon size={32} />
                        </WhatsappShareButton>
                        &nbsp;&nbsp;
                        <TwitterShareButton url={window.location.href}>
                          <TwitterIcon size={32} />
                        </TwitterShareButton>
                        &nbsp;&nbsp;
                        <LinkedinShareButton url={window.location.href}>
                          <LinkedinIcon size={32} />
                        </LinkedinShareButton>
                        <Button
                          style={{
                            padding: 0,
                            margin: 0,
                            marginTop: "-3vh",
                            width: "2vh",
                            height: "2vh",
                          }}
                        >
                          <FileCopyIcon
                            style={{
                              padding: 0,
                              margin: 0,
                              width: "5vh",
                              height: "4vh",
                            }}
                            onClick={() => {
                              setOpen(true);
                              copy(window.location.href, {
                                debug: true,
                                // message: window.location.href,
                              });
                              // navigator.clipboard.writeText(
                              //   window.location.href
                              // );
                            }}
                          />
                        </Button>
                      </CardContent>
                      <CardActions>
                        <Button
                          color="secondary"
                          onClick={() => {
                            history.push({
                              pathname: `/new-appointment/${data.id}`,
                              state: {
                                offer: offer ? offer : "",
                              },
                            });
                            // redirect(`/new-appointment/${data.id}`);
                          }}
                        >
                          BOOK APPOINTMENT
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Loading />
            )}
          </div>
        )}
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success">
            Copied
          </Alert>
        </Snackbar>
      </AppProvider>
    </div>
  );
};
export default MentorDetails;
